function ForageChart({ history, baseline }) {
    const width = 420;
    const height = 116;
    const historyValues = history.map(({ value }) => value);
    const values = [...historyValues, baseline];
    const minimum = values.length ? Math.min(...values, 0) : 0;
    const maximum = values.length ? Math.max(...values, 1) : 1;
    const range = maximum - minimum || 1;
    const points = history.map(({ value }, index) => {
        const x = history.length <= 1 ? 0 : (index / (history.length - 1)) * width;
        const y = height - (((value - minimum) / range) * (height - 12)) - 6;
        return `${x},${y}`;
    }).join(' ');
    const baselineY = height - (((baseline - minimum) / range) * (height - 12)) - 6;

    return (
        <div className="forage-chart" aria-label="Moves toward visible food over training">
            <div className="forage-chart-label">
                <span>Moves toward visible food</span>
                <span>{historyValues.length ? `${historyValues[historyValues.length - 1].toFixed(0)}%` : '—'}</span>
            </div>
            <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-hidden="true" preserveAspectRatio="none">
                <line x1="0" x2={width} y1={height - 1} y2={height - 1} />
                <line className="forage-chart-baseline" x1="0" x2={width} y1={baselineY} y2={baselineY} />
                {points && <polyline points={points} />}
            </svg>
            <p className="forage-chart-note">Dotted line: random choice ({baseline.toFixed(0)}%)</p>
        </div>
    );
}

export default ForageChart;
